var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('v-app',[_c('Nuxt'),_vm._v(" "),(_vm.shouldNotify && _vm.toast.show)?_c('v-snackbar',{attrs:{"value":true,"timeout":-1,"color":_vm.toast.color,"min-width":50,"bottom":""}},[_vm._v("\n      "+_vm._s(_vm.toast.message)+"\n    ")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }